export const DAILY_GOAL_QUESTION =
  'How much time can you give yourself each day?'

export const DAILY_GOAL_OPTIONS = [
  { key: 'casual', i18nKey: 'casual' },
  { key: 'regular', i18nKey: 'regular' },
  { key: 'serious', i18nKey: 'serious' },
  { key: 'determined', i18nKey: 'determined' },
] as const
